var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EDD331B4-FEE0-46D5-B7E7-7ED47A944CC0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 88.5245902,
    height: 48.3606557,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-111.000000, -1489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image-Gallery",
    transform: "translate(111.000000, 1489.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-50",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.000000, 18.777778)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-64",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 104,
    height: 66
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F3F3F3",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4136205,-1.03175354 L45.413,-1.02675354 L88.5245902,-0.887481061 L88.5245902,48.3606557 C87.4619922,47.9600644 79.9864231,47.5180627 78.7143691,47.2994314 L78.7143691,44.9754293 C78.8206737,44.9351917 78.9180034,44.9311674 79.0207277,44.8833288 C79.2207794,44.9553105 79.4275599,45.0156613 79.6410578,45.0156613 C80.6682202,45.0156613 81.5092938,44.1773724 81.5092938,43.1531404 C81.5092938,42.3649255 80.9670001,41.7430589 80.245737,41.4787831 C80.2538107,41.4188729 80.2699586,41.3504679 80.2699586,41.2905623 C80.2699586,40.2662846 79.4289424,39.4360533 78.4017227,39.4360533 C77.3745029,39.4360533 76.5334867,40.2738958 76.5334867,41.2982308 C76.5339352,41.358141 76.5496337,41.4184998 76.5577083,41.4784053 C75.9135975,41.7149145 75.4726846,42.2643885 75.3726932,42.9336965 C75.2892645,42.8854104 75.2363361,42.801364 75.1452783,42.7696143 C75.1493151,42.7177526 75.1614253,42.6654422 75.1614253,42.6135782 C75.1614253,41.7511394 74.4567662,41.048754 73.59151,41.048754 C72.7262537,41.048754 72.0215946,41.7515743 72.0215946,42.6135782 C72.0220432,42.6654399 72.0296685,42.7177503 72.0377416,42.7696143 C71.4308577,42.9940484 70.9706539,43.5149088 70.9702061,44.1775212 C70.9702061,45.03996 71.6829375,45.7423455 72.5481593,45.7423455 C72.7284722,45.7423455 72.8966823,45.6940593 73.0662245,45.6341503 C73.1518958,45.674388 73.2447461,45.674388 73.3331055,45.7101551 L73.3331055,46.8837733 C72.3292645,46.8837733 71.403437,46.9839211 70.5462532,47.1122362 C70.2143341,46.2310268 69.8119917,45.3668025 69.314159,44.5772942 L67.7442437,42.0892785 L61.0722184,31.5111489 C59.5794669,29.1500635 57.172118,29.1500635 55.6793664,31.5111489 L53.5205032,34.9380362 L47.8926002,26.0185837 C47.1477794,24.8405005 46.3773095,24.2247906 45.4071555,24.2222302 C44.4362527,24.2247484 43.3768362,24.8404601 42.6319899,26.0185837 L42.6319899,26.0185837 L37.004087,34.9380362 L34.8452237,31.5111489 C33.3524722,29.1500635 30.9451233,29.1500635 29.4523717,31.5111489 L29.4523717,31.5111489 L22.7803465,42.0892785 L21.2104312,44.5772942 C20.7125985,45.3668025 20.310256,46.2310268 19.978337,47.1122362 C19.1211531,46.9839211 18.1953257,46.8837733 17.1914847,46.8837733 L17.1914847,46.8837733 L17.1914847,45.7101551 C17.2798441,45.674388 17.3726944,45.674388 17.4583657,45.6341503 C17.6279078,45.6940593 17.796118,45.7423455 17.9764309,45.7423455 C18.8416526,45.7423455 19.5543841,45.03996 19.5543841,44.1775212 C19.5539362,43.5149088 19.0937324,42.9940484 18.4868485,42.7696143 C18.4949217,42.7177503 18.502547,42.6654399 18.5029955,42.6135782 C18.5029955,41.7515743 17.7983364,41.048754 16.9330802,41.048754 C16.067824,41.048754 15.3631649,41.7511394 15.3631649,42.6135782 C15.3631649,42.6654422 15.375275,42.7177526 15.3793119,42.7696143 C15.288254,42.801364 15.2353257,42.8854104 15.1518969,42.9336965 C15.0519055,42.2643885 14.6109927,41.7149145 13.9668818,41.4784053 C13.9749565,41.4184998 13.9906549,41.358141 13.9911035,41.2982308 C13.9911035,40.2738958 13.1500872,39.4360533 12.1228675,39.4360533 C11.0956477,39.4360533 10.2546315,40.2662846 10.2546315,41.2905623 C10.2546315,41.3504679 10.2707794,41.4188729 10.2788531,41.4787831 C9.55759004,41.7430589 9.01529637,42.3649255 9.01529637,43.1531404 C9.01529637,44.1773724 9.85637001,45.0156613 10.8835323,45.0156613 C11.0970303,45.0156613 11.3038108,44.9553105 11.5038625,44.8833288 C11.6065867,44.9311674 11.7039164,44.9351917 11.810221,44.9754293 L11.810221,44.9754293 L11.810221,47.2994314 C10.538167,47.5180627 1.06259796,47.8216309 0,48.2222222 L0,48.2222222 L0,-1.03175354 L45.4136205,-1.03175354 Z M71.7587039,5.22222222 L71.7582598,5.22222222 C70.0345809,5.22355369 68.3819451,5.90919 67.1639802,7.12819984 C65.9460152,8.34719831 65.2618406,9.99937863 65.2622951,11.7222222 C65.2618513,13.4449522 65.9460834,15.097587 67.1639802,16.3162446 C68.3823998,17.5352431 70.0345809,18.2209723 71.7582598,18.2222222 C73.4833028,18.2226658 75.1376436,17.5383673 76.3578819,16.319312 C77.5775519,15.1003135 78.2627495,13.4463155 78.2622951,11.7222222 C78.262739,9.99812895 77.5776201,8.34469897 76.3578819,7.12558689 C75.138212,5.90658841 73.4833028,5.22176802 71.7582598,5.22222222 L71.7587039,5.22222222 Z M76.4028163,43.2222222 C76.6868386,43.4680881 77.0106507,43.6474731 77.3805917,43.6474731 C77.5829214,43.6474731 77.7831273,43.5767726 77.9731907,43.4913064 C78.0692756,43.5387913 78.1632432,43.5435403 78.2622951,43.599995 L78.2622951,46.2222222 C76.934452,45.9763563 75.5668408,45.862912 74.2622951,45.862912 L74.2622951,44.4779157 C74.3465276,44.4304309 74.4324527,44.4304309 74.5141453,44.3882219 C74.6733045,44.4589223 74.833298,44.5159038 75.003033,44.5159038 L75.0106521,44.5159038 C75.6675845,44.5159038 76.2093301,43.9640259 76.4032945,43.2232541 L76.4028163,43.2222222 Z",
    fill: "#979797",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.7,
    fill: "#000000",
    fillRule: "evenodd",
    x: 79,
    y: 48.2222222,
    width: 14,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "3/12",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 4,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 82,
    y: 52.2222222,
    fill: "#FFFFFF"
  }, "3/12")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/Gallery.c3b801b5cc5ca0d5ee743907613cf8e5.svg";
export { ForwardRef as ReactComponent };